import { render } from "./OrderMinute.vue?vue&type=template&id=f4950ece&scoped=true"
import script from "./OrderMinute.vue?vue&type=script&lang=js"
export * from "./OrderMinute.vue?vue&type=script&lang=js"

import "./OrderMinute.vue?vue&type=style&index=0&id=f4950ece&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f4950ece"

export default script